/** Slug for human-readable profile URLs (QR, sharing). Numeric id prefix is required for routing. */
export function slugifyProfileSegment(name?: string, lastName?: string): string | undefined {
  const full = [name, lastName].filter(Boolean).join(' ').trim();
  if (!full) {
    return undefined;
  }
  const slug = full
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug || undefined;
}

/** Route segment e.g. `57-marcus-vance` — id prefix is parsed by parsePublicProfileRouteId. */
export function buildPublicProfileIdSegment(
  userId: string | number,
  name?: string,
  lastName?: string
): string {
  const slug = slugifyProfileSegment(name, lastName);
  return slug ? `${userId}-${slug}` : String(userId);
}

/** Extract numeric user id from `/mentor/:id` where id may be `57` or `57-marcus-vance`. */
export function parsePublicProfileRouteId(routeId: string | undefined): string | undefined {
  if (!routeId) {
    return undefined;
  }
  const match = routeId.match(/^(\d+)/);
  return match ? match[1] : routeId;
}

export function isPublicProfilePath(pathname: string): boolean {
  return (
    /^\/mentor\/\d+(?:-[^/]+)?$/.test(pathname) ||
    /^\/mentee\/\d+(?:-[^/]+)?$/.test(pathname)
  );
}

export function profilePathRequiresAuth(pathname: string): boolean {
  return !isPublicProfilePath(pathname);
}
